module.exports = __webpack_public_path__ + "img/company.58985145.png";